import React from 'react';
import classnames from 'classnames';
import { ToggleButton } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Project, System } from '@leverege/api-redux';
import S from './DetailText.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function LabelButton(props) {
  const {
    variant
  } = props;
  return create(variant || 'detailLabel', '--color-detailLabel', S.label, props);
}
export function ValueButton(props) {
  const {
    variant
  } = props;
  return create(variant || 'detailValue', '--color-detailValue', S.value, props);
}
export function SuffixButton(props) {
  const {
    variant
  } = props;
  return create(variant || 'detailSuffix', '--color-detailSuffix', S.suffix, props);
}
export function getEnumValues(type, projectId) {
  return Project(projectId).enum(type).getEnum(GlobalState.get()).values;
}
export function getResourceEnumValues(type, systemId) {
  return System(systemId).resourceEnum(type).getResourceEnum(GlobalState.get()).values;
}
function create(variant, colorVar, cn, props) {
  const {
    className,
    style,
    children,
    variant: oVariant,
    ...rest
  } = props;
  let s = style;
  if (s?.color) {
    s = {
      [colorVar]: s.color,
      ...s
    };
  }
  const ch = children && typeof children === 'object' ? null : children;
  return /*#__PURE__*/_jsx(ToggleButton, {
    variant: oVariant || variant,
    style: s,
    className: classnames(cn, className),
    ...rest,
    children: ch
  });
}